import FillBlanksSenseOrgan from "../../components/UKG/GeneralAwareness/FillBlanksSenseOrgan";
import MatchSenseOrgan from "../../components/UKG/GeneralAwareness/MatchSenseOrgan";
import TrueFalseSenseOrgan from "../../components/UKG/GeneralAwareness/TrueFalseSenseOrgan";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/sense-organ/fill-the-blanks", title: "Fill In The Blanks", component: FillBlanksSenseOrgan},
    { url: "/ukg/general-awareness/sense-organ/true-false", title: "True & False", component: TrueFalseSenseOrgan},
    { url: "/ukg/general-awareness/sense-organ/choose-correct-image", title: "Match Image", component: MatchSenseOrgan},
];


export default topics;